// @ts-nocheck
import React from 'react';
import { driverQualifications } from '../../lib/enum';
import { Option, Select } from './../ant/Select';
import {
  getLabeledSelectValue,
  toLabeledSelectValue,
} from './labelInValue';
export default ({
  value,
  onChange,
  multiple,
  exclude = [],
  disabledValues = [],
  ...selectProps
}) => <Select placeholder="Выберите квалификации сотрудников" showSearch optionFilterProp="label" mode={multiple ? 'multiple' : 'default'} labelInValue={multiple} value={multiple ? (value || []).map(key => toLabeledSelectValue(key, driverQualifications[key])) : value} onChange={value => {
  multiple ? onChange(value.map(getLabeledSelectValue)) : onChange(value);
}} allowClear {...selectProps}>
    {Object.keys(driverQualifications).filter(qualification => !exclude.includes(qualification)).map(key => <Option key={key} value={key} label={driverQualifications[key]} disabled={disabledValues.includes(key)}>
          {driverQualifications[key]}
        </Option>)}
  </Select>;
